import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { setPassword as savePassword } from "../../services/api/authApi";
import { useAuth } from "../../Context/AuthContext";
import { extractErrorMessage } from "../../services/api/errorHandler";
import AuthLayout from "./components/AuthLayout";
import { AlertIcon, CheckIcon, ShieldIcon, SpinnerIcon } from "./components/AuthIcons";
import { dashboardPathFor } from "./components/loginUtils";

function SetPassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const { token, user, login } = useAuth();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) navigate("/LoginNumber", { replace: true });
    else if (user?.hasPassword === true) navigate(dashboardPathFor(user), { replace: true });
  }, [navigate, token, user]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (password.length < 8) return setError("رمز عبور باید حداقل ۸ کاراکتر باشد");
    if (password !== confirm) return setError("تکرار رمز عبور با رمز اصلی یکسان نیست");
    setLoading(true);
    setError("");
    try {
      const response = await savePassword(password);
      if (!response.success || !response.data) throw new Error(response.message || "ذخیره رمز عبور ناموفق بود");
      login(response.data.token || token, response.data.user);
      navigate(dashboardPathFor(response.data.user), { replace: true });
    } catch (err) {
      if (err?.response?.status === 404 && user?.hasPassword !== false) {
        navigate(dashboardPathFor(user), { replace: true });
        return;
      }
      setError(extractErrorMessage(err, "ذخیره رمز عبور ناموفق بود"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout badgeIcon={<ShieldIcon size={26} />} title="ساخت رمز عبور" subtitle={`برای ورودهای بعدی ${location.state?.phone || "حساب شما"} یک رمز عبور بسازید`}>
      <form className="auth-form" onSubmit={handleSubmit} noValidate>
        <div className="auth-field"><label className="auth-label" htmlFor="new-password"><ShieldIcon size={17} />رمز عبور جدید</label><div className="auth-input-wrap"><input id="new-password" className="auth-input" type="password" autoComplete="new-password" value={password} onChange={(e) => { setPassword(e.target.value); setError(""); }} disabled={loading} autoFocus /></div><p className="auth-hint">حداقل ۸ کاراکتر وارد کنید</p></div>
        <div className="auth-field"><label className="auth-label" htmlFor="confirm-password"><CheckIcon size={17} />تکرار رمز عبور</label><div className="auth-input-wrap"><input id="confirm-password" className="auth-input" type="password" autoComplete="new-password" value={confirm} onChange={(e) => { setConfirm(e.target.value); setError(""); }} disabled={loading} /></div></div>
        {error && <p className="auth-alert auth-alert-error" role="alert"><AlertIcon size={18} /><span>{error}</span></p>}
        <button className="auth-btn auth-btn-primary" type="submit" disabled={loading || !password || !confirm}>{loading && <SpinnerIcon />}{loading ? "در حال ذخیره..." : "ذخیره و ورود به داشبورد"}</button>
      </form>
    </AuthLayout>
  );
}

export default SetPassword;
